import { Component } from '@theme/component';

/** @extends {Component} */
class ProductUpsellToggle extends Component {
  connectedCallback() {
    super.connectedCallback();

    const input = this.querySelector('input[type="checkbox"]');
    if (input instanceof HTMLInputElement && this.dataset.available === 'false') {
      input.disabled = true;
    }
  }
}

if (!customElements.get('product-upsell-toggle')) {
  customElements.define('product-upsell-toggle', ProductUpsellToggle);
}

export default ProductUpsellToggle;
